// React
import React, { useEffect, useState } from 'react';

// React-router-dom
import { Link as LinkRouter, useNavigate } from 'react-router-dom';

// Chakra-ui
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
  Avatar,
  Button,
  Portal,
  Stack,
  Text,
  Box,
  SimpleGrid,
  useDisclosure,
  useOutsideClick,
} from '@chakra-ui/react';

// Supabase client
import { supabase } from '../../client';

// Images && Icons
const logoIcon = require('../../assets/images/welcome-home/empty-image.png');

const AvatarMenu = () => {
  const navigate = useNavigate();
  const { isOpen, onToggle, onClose } = useDisclosure();
  const [avatar, setAvatar] = useState('');

  const ref = React.useRef();
  useOutsideClick({
    ref: ref,
    handler: () => onClose(),
  })

  
  useEffect(() => {
    getUser();
  }, []);

  const getUser = async() => {
    const user = await supabase.auth.user();
    const userId = user.id;
    const token = localStorage.getItem('auth-token');
    try {
      const { data } = await supabase
      .from('profiles')
      .select('avatar_url')
      .eq('id', userId)

      const userAvatar = data[0].avatar_url;
      if(!userAvatar) {
        setAvatar(logoIcon);
      } else {
        const { data:bucketData } = await supabase.storage
        .from('avatars')
        .getPublicUrl(`${userAvatar}?token=${token}`)
        console.log(bucketData);
        setAvatar(bucketData.publicURL);
      }
    } catch(err) {
      console.log(err);
    }
  }

  return(
    <Box>
      <Avatar cursor='pointer' h='40px' w='40px' border='1px solid #007472' onClick={() => navigate('/my-account')} src={avatar}/>
    </Box>
  )
}
export default AvatarMenu;